import React from "react";

class PanelHeader extends React.Component {
  render() {
    return (
      <div
        className={
          "panel-header " +
          (this.props.size !== undefined
            ? "panel-header-" + this.props.size
            : "") + " " +
            (this.props.className !== undefined
              ? this.props.className : "")
        }
      >
        {this.props.content}
      </div>
    );
  }
}

export default PanelHeader;



// WEBPACK FOOTER //
// ./src/components/PanelHeader/PanelHeader.jsx